import cn from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

interface IErrorImageProps {
  className?: string;
  alt: string;
  imageSrc: string;
}

export const ErrorImage: React.FC<IErrorImageProps> = ({ className, alt, imageSrc }) => (
  <div className={cn(styles.image, className)}>
    <img src={imageSrc} alt={alt} />
  </div>
);
